import { Component, OnInit, Output, EventEmitter, Input, ElementRef, ViewChild } from "@angular/core"
import { FormControl, FormGroup, FormBuilder } from "@angular/forms"
import { externalRoute } from '../external-routes'
import get from 'lodash-es/get'
import { ICustomer, KeywordQueries, AmFont, Request, SourceContent } from "graphql/queries/keyword.queries"
import { UploadsService } from "services/uploads-service"
import { standAloneVideoHelpString } from '../keyword-form/help-strings'
import { startWith, map } from "rxjs/operators"
import { Observable } from "rxjs"
import { TinymceConfig, tinymceConfig } from "src/tinymce"
import { omit } from "lodash-es"
import { RequestActivationMethod } from '../../../graphql/queries/keyword.queries'
import { waitUntil, stripImages } from "src/utils"
import { NgxFileDropService } from 'src/services/ngx-file-drop.service'
import { NgxFileDropEntry } from 'ngx-file-drop'

@Component({
  styles: [`
    :host { display: block; }
    mat-form-field{
      display: block;
    }
    .fade{
      opacity: 1;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      margin: 0;
      padding: 20px 0;
      background-image: linear-gradient(to bottom, transparent, #fafafa 120%);
    }
    .hover-icon {
      position: absolute;
      top: -9px;
      left: 100%;
      margin-left: -9px;
    }
    .readonly-preferences{
      height: 240px;
      background-color: white;
      border: 1px solid gray;
      padding: 5px;
      overflow: auto;
    }
  `],
  template: `
  <source-content-form
    [viewOnly]="viewOnly"
    [hidden]="sourceContentFormHidden"
    [customer]="customer"
    [sourceContent]="formSourceContent"
    (create)="setSourceContent($event)"
    (cancel)="onSourceContentCancel()"
    (hideForm)="closeSourceContentComponent()"
    (search)="onSearch($event)">
  </source-content-form>
  <form [formGroup]="form" [hidden]="!sourceContentFormHidden" #formElement="ngForm">
    <div class="p-3" formGroupName="request">
      <div class="row">
        <div class="col-sm-8">
          <mat-form-field class="bottom-buffer">
            <input matInput placeholder="Video Title" formControlName="videoTitle" (blur)="userEditedVideoTitle = true" class="keyword-phrase-input" required/>
          </mat-form-field>
        </div>
        <div class="col-sm-4">
          <div class="d-flex align-items-center bottom-buffer">
            <div class="btn-group">
              <button class="btn"
                [disabled]="viewOnly"
                [ngClass]="{'btn-info text-white': isType('summary'), 'btn-default': isType('teaser'), 'disabled': viewOnly }"
                (click)="setType('summary')"
                [popover]="summaryTip"
                triggers="mouseover:mouseout">
                Summary
                <ng-template #summaryTip>
                  <div class="small" style="min-width: 150px;">Summary videos work best for short posts. At 0-60 seconds, these videos are great to embed in the blog post to drive engagement with the content. Summary videos for longer pieces will identify the top few takeaways.</div>
                </ng-template>
              </button>
              <button
                [disabled]="viewOnly"
                class="btn"
                [ngClass]="{'btn-info text-white': isType('teaser'), 'btn-default': isType('summary'), 'disabled': viewOnly}"
                (click)="setType('teaser')"
                [popover]="teaserTip"
                triggers="mouseover:mouseout">
                  Teaser
                  <ng-template #teaserTip>
                    <div class="small" style="min-width: 150px;">Teaser videos work better for longer, more in-depth content and are meant to entice people to your website to read your content.</div>
                  </ng-template>
              </button>
            </div>
            <div *ngIf="isDeletable" dropdown placement="bottom right">
              <button class="tiny-left-buffer btn btn-link" dropdownToggle>
                <div class="fas fa-ellipsis-v cursor-pointer text-gray"></div>
              </button>
              <div *dropdownMenu class="dropdown-menu dropdown-menu-right">
                <button role="menuitem" class="btn btn-link dropdown-item" (click)="onDelete()">
                  Delete Request
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row bottom-buffer">
        <div class="col-sm-8">
          <editor #editorEl
            class='video-request'
            formControlName="otherPreferences"
            name="otherPreferences"
            [init]="tinymceConfig"
            (onFocus)="populatePlaceholderTemplate(true)"
            (onBlur)="populatePlaceholderTemplate(false)">
          </editor>
        </div>
        <div class="col-sm-4">
          <div class="bottom-buffer cursor-default">
            <i class=" fas fa-video tiny-right-buffer"></i>
            <span>Verblio Vid</span>
          </div>

          <div *ngIf="!shouldShowUploadComp()">
            <div style="width: 120px; height: 120px; position:relative">
              <img [src]="formRequest.logo" class="cursor-pointer" style="max-width: 100%; max-height: 100%;"/>
              <i class="fas fa-times text-danger hover-icon"
                *ngIf="!viewOnly"
                [popover]="removeTip"
                triggers="mouseover:mouseout"
                (click)="removeLogo()">
                <ng-template #removeTip>
                  <div class="small" style="min-width: 150px;">Remove this image</div>
                </ng-template>
              </i>
            </div>
          </div>

          <ngx-file-drop
            *ngIf="shouldShowUploadComp()"
            (onFileDrop)="onFileDrop($event)"
            (onFileOver)="onFileOver(true)"
            (onFileLeave)="onFileOver(false)"
            accept=".gif, .png, .jpg, .jpeg"
            dropZoneClassName="border-none p-0 m-0"
            containerClass="p-0 m-0">
            <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
              <div
                (click)="openFileSelector()"
                [class.over]="fileOver"
                class="d-none d-sm-block form-fill-option-sm w-100 p-2 text-center cursor-pointer">
                <div><i class="fas fa-upload fa-2x text-info"></i></div>
                <div class="text-black">Drag & drop logo or</div>
                <button
                  type="button"
                  class="btn-blank text-info">
                  browse your computer
                </button>
              </div>

              <button
                (click)="openFileSelector()"
                type="button"
                class="d-sm-none btn btn-secondary btn-block">
                Choose a logo
              </button>
            </ng-template>
          </ngx-file-drop>
          <div
            class="editable-field mt-2 empty" (click)="editingAccentColor = true">
            <i class="fas fa-palette tiny-right-buffer"
            [style.background-color] = "formRequest.accentTextColor"
            [style.color] = "formRequest.accentTextColor"
            [class.editable-field-icon-full] = "formRequest.accentTextColor"
            [class.editable-field-icon] = "!formRequest.accentTextColor"
            ></i>
            <span class="text-info" (click)="editingAccentColor = true">
              <span *ngIf="!formRequest.accentTextColor">Add accent color</span>
              <span *ngIf="formRequest.accentTextColor">{{formRequest.accentTextColor}}</span>
            </span>
          </div>
          <pop-card
            *ngIf="editingAccentColor && !viewOnly"
            class="small-bottom-buffer-lg"
            (outsideClick)="closeColorDialog(false)">
            <div class="padding d-flex flex-column align-items-center justify-content-center">
              <p class="font-weight-500 small">The accent color may highlight key information. We recommend a light color for the best readability.</p>
              <input
                style="visibility: hidden; width: 0px;"
                [(colorPicker)]="accentColor"
                [style.background]="accentColor"
                [cpOutputFormat]="'hex'"
                [cpPosition]="'bottom'"
                [cpDialogDisplay]="'inline'"
                [cpToggle]="true"
                >
              <button class="btn btn-secondary top-buffer" style="width: 100%" (click)="closeColorDialog(true)"> Save Color</button>
            </div>
            <div class="row d-flex justify-content-center align-items-center bg-gray text-red padding" (click)="closeColorDialog(false)">
              Cancel
            </div>
          </pop-card>
          <div
            class="editable-field mt-2"
            [class.empty]="!formRequest.font"
            [class.full]="formRequest.font"
            (click)="editingFontPreference = true">
            <div class="editable-field-icon tiny-right-buffer">
              <i class="fas fa-xs fa-font"></i>
            </div>
            <span class="text-info" (click)="editingFontPreference = true">
              <span *ngIf="!formRequest.font">Add font preference</span>
              <span *ngIf="formRequest.font">{{formRequest.font}}</span>
            </span>
          </div>
          <pop-card
            *ngIf="editingFontPreference && !viewOnly"
            class="small-bottom-buffer-lg"
            (keyup.enter)="closeFontDialog(true)">
            <div class="padding">
              <p class="font-weight-500 small">Select your prefered Google font:</p>
              <mat-form-field class="bottom-buffer">
                <input matInput placeholder="Font" aria-label="Font" [matAutocomplete]="autoFont" [formControl]="fontPreference">
                <mat-autocomplete #autoFont="matAutocomplete">
                  <mat-option *ngFor="let font of filteredFonts | async" [value]="font.family">
                    <img class="example-option-img" aria-hidden [src]="font.preview" height="25">
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <button class="btn btn-secondary" style="width: 100%" (click)="closeFontDialog(true)"> Save font preference</button>
            </div>
            <div class="row d-flex justify-content-center align-items-center bg-gray text-red padding" (click)="closeFontDialog(false)">
              Cancel
            </div>
          </pop-card>
          <div
            class="editable-field mt-2 "
            [class.empty]="!formRequest.additionalResources"
            [class.full]="formRequest.additionalResources"
            (click)="editingPhotoPreference = !editingPhotoPreference">
            <i class="editable-field-icon fas fa-link tiny-right-buffer"></i>
            <span class="text-info">
              <span *ngIf="!formRequest.additionalResources">Add link to photo library</span>
              <span *ngIf="formRequest.additionalResources">{{formRequest.additionalResources}}</span>
            </span>
          </div>
          <pop-card
            *ngIf="editingPhotoPreference && !viewOnly"
            class="small-bottom-buffer-lg"
            (outsideClick)="closePhotoDialog(false)">
            <div class="padding">
              <p class="font-weight-500 small">If you'd prefer we not use stock imagery, provide access to a library of approved photos and enter the link below.</p>
              <mat-form-field class="bottom-buffer">
                <input matInput placeholder="URL" class="keyword-phrase-input" [value]="formRequest.additionalResources" #photoLink/>
              </mat-form-field>
              <button class="btn btn-secondary" style="width: 100%" (click)="closePhotoDialog(true)"> Save link to photo library</button>
            </div>
            <div class="row d-flex justify-content-center align-items-center bg-gray text-red padding" (click)="closePhotoDialog(false)">
              Cancel
            </div>
          </pop-card>
        </div>
      </div>
      <div class="row">
        <div (click)="openSourceContentComponent()" class="col-sm-12" style="height: 100px; overflow: hidden">
          <span
            id="priority-picker-anchor"
            class="editable-field full">
            <div class="
              editable-field-icon
              tiny-right-buffer">
              <i class="fas fa-search"></i>
            </div>
            <span *ngIf="formSourceContent.type === 'hubspot'">Imported from Hubspot</span>
            <span *ngIf="formSourceContent.type === 'copypaste'">Pasted content</span>
            <span *ngIf="formSourceContent.type === 'url'">
              Imported via public URL:
              <a [href]="formSourceContent.externalIdentifier"
                target="_blank"
                (click)="$event.stopPropagation()">
                {{formSourceContent?.externalIdentifier}}
              </a>
            </span>
          </span>
          <div *ngIf="formSourceContent" [innerHtml]="sourceContentHtml"></div>
          <div class="fade"></div>
        </div>
      </div>
      <div class="row top-buffer" >
        <div class="col-sm-12" *ngIf="!viewOnly">
          <button
          (click)="onSave('draft')"
          class="btn btn-outline-primary btn-block-sm-down"
          [disabled]="formElement.invalid || submitting">
            <span *ngIf="!submitting || formRequest.state === 'active'">Save progress</span>
            <span *ngIf="submitting && formRequest.state === 'draft'">Saving progress...</span>
          </button>
          <button id="activate-keyword-btn" (click)="onSave('active')"
            class="btn btn-primary mt-2 mt-md-0 ml-md-2 btn-block-sm-down"
            [disabled]="formElement.invalid || submitting">
            <span *ngIf="!submitting || formRequest.state === 'draft'">Activate</span>
            <span *ngIf="submitting && formRequest.state === 'active'">Activating...</span>
          </button>
          <button (click)="onCancel()" class="d-none d-md-block float-right btn btn-link no-decoration">Cancel</button>
        </div>
        <div class="col-sm-12" *ngIf="viewOnly">
          <button class="btn btn-outline-primary ml-md-2 btn-block-sm-down" (click)="onCancel()">Done Viewing</button>
        </div>
        <div class="col-sm-12 top-buffer">
          <hr class="tiny-top-buffer tiny-bottom-buffer"/>
          <span class="text-muted small">
            {{bottomHelperText}}
          </span>
        </div>
      </div>
    </div>
  </form>
  <activate-request-modal *ngIf="activateRequestModalVisible"
                          [price]="customer.plan.extraPostPrice"
                          [availableCredits]="customer.postCreditsCount"
                          (onActivate)="activate($event)"
                          (onClose)="activateRequestModalVisible = false; submitting = false">
  </activate-request-modal>
  `,
  selector: 'video-form'
})
export class VideoFormComponent implements OnInit {
  @Input() customer: ICustomer;
  @Input() request: Request;
  @Input() duplicateId: number;
  @Input() viewOnly: boolean = false;
  @Output() cancel: EventEmitter<null> = new EventEmitter();
  @Output() save: EventEmitter<{ request: Request, activationMethod: 'charge' | 'credit' }> = new EventEmitter();
  @Output() search: EventEmitter<string> = new EventEmitter();
  @Output() delete: EventEmitter<{request: Request}> = new EventEmitter()
  @ViewChild('photoLink') photoLink: ElementRef;
  @ViewChild('editorEl') editorEl: ElementRef<any>;

  form: FormGroup;
  uploadsService: UploadsService = new UploadsService();
  sourceContentFormHidden: boolean = false;
  editingFontPreference: boolean = false;
  editingPhotoPreference: boolean = false;
  editingAccentColor: boolean = false;
  toggleColorPicker: boolean = false;
  accentColor: string = '#4ff0eb';
  fonts: AmFont[];
  fontPreference: FormControl = new FormControl();
  filteredFonts: Observable<AmFont[]>;
  userEditedVideoTitle: boolean = false // For knowing to prepopulate request videoTitle automatically or not from source content
  activateRequestModalVisible: boolean = false;
  submitting: boolean = false;
  tinymcePlaceholder: string = ''

  tinymceConfig: TinymceConfig = tinymceConfig(<TinymceConfig>{
    placeholder: this.tinymcePlaceholder,
    toolbar: 'bold italic underline | numlist bullist | link | blockquote',
  })

  constructor(
    private fb: FormBuilder,
    private elementRef: ElementRef,
    private keywordQueries: KeywordQueries,
    private fileDropService: NgxFileDropService,
  ) {}

  ngOnInit(): void {
    this.resetForm()
    this.keywordQueries.fontListQuery().subscribe(({data}) => {
      if (data) {
        this.fonts = data.amFontList
        this.filteredFonts = this.fontPreference.valueChanges.pipe(
          startWith<string | AmFont>(''),
          map(value => typeof value === 'string' ? value : value.family),
          map((name) => name ? this._filterFonts(name) : this.fonts)
        )
      }
    })
    if (this.viewOnly) this.form.get('request').get('videoTitle').disable()
    if (this.duplicateId) {
      // this.sourceContentFormHidden = true;
      this.keywordQueries.duplicateRequestPageQuery(this.customer.id, +this.duplicateId).subscribe(({data}) => {
        if (data) {
          const requestData = <Request>omit(data.customer.request, '__typename')
          const sourceContent = <SourceContent>omit(data.customer.request.sourceContent, '__typename')
          this.userEditedVideoTitle = true
          this.updateFormRequest({
            ...requestData,
            sourceContent,
            id: this.duplicateId ? null : data.customer.request.id,
            videoTitle: (this.duplicateId ? '[copy of] ' : '') + data.customer.request.videoTitle })
        }
      })
    }
    this.waitForPlaceholder()
      .then(_el => {
        this.tinymcePlaceholder = standAloneVideoHelpString
        const placeHolderEl = document.querySelector('editor.video-request placeholder')
        if (placeHolderEl) placeHolderEl.innerHTML = this.tinymcePlaceholder
      })
      .catch(e => console.log('Timed out waiting for TinyMCE placeholder', e))
  }

  private _filterFonts(value: string): AmFont[] {
    const filterValue = value.toLowerCase()
    const result = this.fonts.filter(font => font.family.toLowerCase().indexOf(filterValue) === 0)
    return result.length > 0 ? result : []
  }

  resetForm(): void {
    const r = this.request
    this.form = this.fb.group({
      request: this.fb.group({
        id: r ? r.id : '',
        type: r ? r.type : 'VideoRequest',
        videoType: r ? r.videoType : 'summary',
        state: r ? r.state : 'active',
        accentTextColor: r ? r.accentTextColor : '',
        font: r ? r.font : '',
        videoTitle: r ? r.videoTitle : '',
        logo: r ? r.logo : null,
        otherPreferences: [{value: r ? r.otherPreferences : '', disabled: this.viewOnly}],
        additionalResources: r ? r.additionalResources : '',
        sourceContent: this.fb.group({
          id: r ? r.sourceContent.id : null,
          type: r ? r.sourceContent.type : 'hubspot',
          externalIdentifier: r ? r.sourceContent.externalIdentifier : '',
          content: r ? r.sourceContent.content : '',
        })
      })
    })
    this.sourceContentFormHidden = !!(r && r.sourceContent)
  }

  get formRequest(): Request {
    return this.form.get('request').value as Request
  }

  updateFormRequest(updates: Partial<Request>): void {
    this.form.markAsDirty()
    this.form.patchValue({ request: updates })
  }

  get formSourceContent(): SourceContent {
    return this.form.get('request').get('sourceContent').value as SourceContent
  }

  get bottomHelperText(): string{
    if (this.viewOnly) {
      return "This request is active and being worked on by our team. You may not make changes. We'll deliver a draft video within 72 hours or 3 business days."
    } else {
      return "Once activated you will not be able to make changes. We'll send your video in 72 hours. You may request one round of edits."
    }
  }

  get sourceContentHtml(): string {
    return stripImages(this.formSourceContent.content)
  }

  isType(type: string): boolean {
    return this.formRequest.videoType === type
  }

  setType(videoType: string): void {
    this.form.patchValue({ request: { videoType }})
  }

  shouldShowUploadComp(): boolean {
    return !this.formRequest.logo
  }

  onSave(state: Request['state']): void {
    this.submitting = true
    if (state === 'active') {
      this.activateRequestModalVisible = true
    } else {
      const formrequest = this.form.get('request')
      formrequest.patchValue({state})
      const request = { ...this.form.get('request').value, state }
      this.save.emit({ request, activationMethod: null })
    }
  }

  get isDeletable(): boolean {
    return true && this.request && ['draft'].includes(this.request.state)
  }

  onDelete(): void {
    this.delete.emit({ request: this.request })
  }

  activate(activationMethod: RequestActivationMethod): void {
    const request = { ...this.form.get('request').value, state: 'active' }
    this.save.emit({ request, activationMethod })
  }

  setSourceContent({sourceContent, title}: {sourceContent: SourceContent, title: string}): void {
    this.sourceContentFormHidden = true
    this.updateFormRequest({
      sourceContent,
      videoTitle: this.userEditedVideoTitle ? this.formRequest.videoTitle : title
    })
  }

  hasAccentColor(): boolean {
    return this.formRequest.accentTextColor !== ''
  }

  closeColorDialog(save: boolean): void {
    if (save && this.accentColor && this.accentColor !== '') {
      this.updateFormRequest({ accentTextColor: this.accentColor })
    }
    this.editingAccentColor = false
  }

  closeFontDialog(save: boolean): void {
    const font = this.fontPreference.value
    if (save) {
      this.updateFormRequest({ font })
    }
    this.editingFontPreference = false
  }

  closePhotoDialog(save: boolean): void {
    const link = this.photoLink.nativeElement.value
    if (save && link && link !== '') {
      this.updateFormRequest({ additionalResources: link })
    }
    this.editingPhotoPreference = false
  }

  onCancel(): void {
    this.cancel.emit()
  }

  onSourceContentCancel(): void {
    if (this.formSourceContent.content) {
      this.sourceContentFormHidden = true
    } else {
      this.onCancel()
    }
  }

  uploadClicked(event: Event, id: string): void {
    if (!this.viewOnly) {
      const uploader = this.elementRef.nativeElement.querySelector(`#${id}`)
      if (uploader) uploader.click()
    }
  }

  public fileOver: boolean = false;
  onFileOver(fileOver: boolean): void {
    this.fileOver = fileOver
  }

  onFileDrop(files: NgxFileDropEntry[]): void {
    this.onFileOver(false)
    this.fileDropService.ngxFileDropToFile(files).then(file => {
      this.uploadsService.prepareAndUpload(file).then(url => this.updateFormRequest({ logo: url }))
    })
  }

  onUploaderChange(e: Event): void {
    if ((<HTMLInputElement>e.target).files && (<HTMLInputElement>e.target).files[0]) {
      const file = (<HTMLInputElement>e.target).files[0]
      this.uploadsService.prepareAndUpload(file).then(url => this.updateFormRequest({ logo: url }))
    }
  }

  removeLogo(): void {
    this.updateFormRequest({ logo: null })
  }

  openSourceContentComponent(): void {
    this.sourceContentFormHidden = false
  }

  closeSourceContentComponent(): void {
    this.sourceContentFormHidden = true
  }

  selectText(): void {
    if (this.htmlToText(this.formRequest.otherPreferences) === this.htmlToText(this.tinymceConfig.placeholder)) {
      const ed = get(this.editorEl, 'editor', null)
      if (ed) {
        if (ed.selection) {
          ed.selection.select(ed.getBody())
        }
      }
    }
  }

  populatePlaceholderTemplate(populate: boolean): void {
    if (populate && !this.formRequest.otherPreferences) {
      this.updateFormRequest({ otherPreferences: this.tinymceConfig.placeholder })
      this.selectText()
    } else if (!populate) {
      if (this.htmlToText(this.tinymceConfig.placeholder) === this.htmlToText(this.formRequest.otherPreferences)) {
        this.updateFormRequest({ otherPreferences: '' })
      }
    }
  }

  private htmlToText(html: string): string {
    const div = document.createElement("div")
    div.innerHTML = html
    return (div.textContent || div.innerText || "").replace(/\n|\r|\s+/g, "").trim()
  }

  linkTo(externalRouteKey: string): string {
    return externalRoute(externalRouteKey)
  }

  onSearch(query: string): void {
    this.search.emit(query)
  }

  waitForPlaceholder = waitUntil(() => document.querySelector('editor.video-request placeholder'), 100, 2000);
}
